import Vuex from 'vuex';
import Vue from 'vue';
import tab from './modules/tab'
import user from './modules/user'
// import getters from './getters'
// console.log(basic)
Vue.use(Vuex);

export default new Vuex.Store({
    strict: true,
    modules: {
      tab,
      user
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js